module.exports = __webpack_public_path__ + "fb.png?e1632d968bddea59a156f479e35a7668";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fb.png
// module id = 937
// module chunks = 0